module.exports = __webpack_public_path__ + "img/capitalbox.fb4d3ef.png";